import React, { useEffect } from 'react';

import Utils from '@/utils/util';
import { AppointmentData, Business } from '../types';

import DateIcon from '@/assets/img/day-icon.png';
import TimeIcon from '@/assets/img/time-icon.png';
import UserIcon from '@/assets/img/v2/user-default-icon.png';

import CheckInIconBoarding from '@/assets/img/checkin-icon.svg';
import CheckOutIconBoarding from '@/assets/img/checkout-icon.svg';
import CheckInIcon from '@/assets/img/check-in-icon.svg';
import CheckOutIcon from '@/assets/img/check-out-icon.svg';
import BackIcon from '@/assets/img/back-icon.svg';
import { ReactComponent as ConfirmIcon } from '@/assets/img/v2/confirm-icon.svg';
import { useTranslation } from 'react-i18next';
import './AppointmentConfirmation.scss';
import { PetConfirmationDisplay } from './PetConfirmationDisplay';
import { Button } from 'react-bootstrap';
export type AppointmentConfirmationProps = {
  business?: Business;
  appointmentData?: AppointmentData;
  isPaymentConfirmation?: boolean;
};

export const AppointmentFormConfirmation = ({
  appointmentData,
  business,
  isPaymentConfirmation,
}: AppointmentConfirmationProps) => {
  const { t } = useTranslation();
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const registrationRuqired = appointmentData?.selectedLocation?.registrationRequired;
  useEffect(() => {
    Utils.scrollToTop();
  }, []);
  let last4Digit;
  const customerCard = appointmentData?.paymentCard
    ? appointmentData.paymentCard
    : appointmentData?.creditCard;
  if (registrationRuqired) {
    last4Digit = customerCard?.number.split('-')[3];
  }

  const servicePrice = appointmentData?.room
    ? appointmentData.room.perHourPrice
    : appointmentData?.service?.price
    ? appointmentData?.service?.price
    : 0;
  const petData =
    appointmentData?.petProfiles && appointmentData?.petProfiles.length
      ? appointmentData?.petProfiles
      : appointmentData?.petProfile
      ? [appointmentData?.petProfile]
      : [];
  return (
    <div className="appointment-confirmation">
      <div className="top">
        {isPaymentConfirmation ? (
          <h5>
            <ConfirmIcon /> {t('Payment')} <span>{t('successfull')}</span>
          </h5>
        ) : appointmentData?.selectedServiceType === Utils.SERVICE_TYPES.GROOMING ? (
          <h5>
            <ConfirmIcon />{' '}
            {appointmentData?.selectedLocation?.reservationType === 'REQUEST'
              ? t('Your appointment has been')
              : t('You are')}
            <span>
              {' '}
              {appointmentData?.selectedLocation?.reservationType === 'REQUEST'
                ? t('requested')
                : t('scheduled')}
            </span>
          </h5>
        ) : (
          <h5>
            <ConfirmIcon />{' '}
            {appointmentData?.selectedLocation?.reservationType === 'REQUEST'
              ? t('Your booking has been')
              : t('You are')}
            <span>
              {' '}
              {appointmentData?.selectedLocation?.reservationType === 'REQUEST'
                ? t('requested')
                : t('scheduled')}
            </span>
          </h5>
        )}
        {!isPaymentConfirmation ? (
          appointmentData?.selectedServiceType === Utils.SERVICE_TYPES.GROOMING ? (
            <p>
              {t('The appointment for your furry mate has been')}{' '}
              {appointmentData?.selectedLocation?.reservationType === 'REQUEST'
                ? t('requested')
                : t('booked')}{' '}
              {t('successfully.')}
              {appointmentData?.selectedLocation?.reservationType === 'REQUEST' ? (
                <>
                  <br />
                  <br />
                  {t(
                    'If it is accepted the booking amount will be deducted from your saved card. If you do not have a saved card, you will receive an email to pay the booking amount.'
                  )}
                </>
              ) : (
                ''
              )}
            </p>
          ) : (
            <p>
              {t('The room for your furry mate has been')}{' '}
              {appointmentData?.selectedLocation?.reservationType === 'REQUEST'
                ? t('requested')
                : t('booked')}{' '}
              {t('successfully.')}
              {appointmentData?.selectedLocation?.reservationType === 'REQUEST' ? (
                <>
                  <br />
                  <br />
                  {t(
                    'If it is accepted the booking amount will be deducted from your saved card. If you do not have a saved card, you will receive an email to pay the booking amount.'
                  )}
                </>
              ) : (
                ''
              )}
            </p>
          )
        ) : (
          <p>
            {t('Your payment is successfull for the')}{' '}
            {appointmentData && appointmentData?.room ? t('booking') : t('appointment')} #
            {appointmentData?.id}
          </p>
        )}
      </div>
      {/* {((!appointmentData?.selectedServiceType && appointmentData?.room) ||
        appointmentData?.selectedServiceType === Utils.SERVICE_TYPES.DAY_CARE) && (
        <div className="time-container">
          <div className="schedule-demo-date">
            <p>
              <img src={CheckInIcon} />

              <span>
                {appointmentData?.slot?.start &&
                  Utils.formatDateStringTz(
                    appointmentData.slot?.start,
                    appointmentData?.selectedLocation?.timezone,
                    "DD MMM 'yy, hh:mma"
                  )}
              </span>
            </p>
            <p>Check-in Time</p>
          </div>
          <div className="schedule-demo-time">
            <p>
              <img src={CheckOutIcon} />
              <span>
                {appointmentData?.slot?.end &&
                  Utils.formatDateStringTz(
                    appointmentData.slot?.end,
                    appointmentData?.selectedLocation?.timezone,
                    "DD MMM 'yy, hh:mma"
                  )}
              </span>
            </p>
            <p>Check-out Time</p>
          </div>
        </div>
      )} */}
      {(appointmentData?.selectedServiceType === Utils.SERVICE_TYPES.BOARDING ||
        appointmentData?.accomodationType === Utils.ACCOMODATION_TYPES.BOARDING) && (
        <div className="time-container boarding">
          <div className="schedule-demo-date">
            <p>
              <img src={CheckInIconBoarding} />

              <span>
                {appointmentData?.startDate &&
                  Utils.formatDateStringTz(
                    appointmentData.startDate,
                    appointmentData?.selectedLocation?.timezone,
                    "DD MMM 'yy, hh:mma"
                  )}
              </span>
            </p>
            <p>{t('Check-in Time')}</p>
          </div>
          <div className="schedule-demo-time">
            <p>
              <img src={CheckOutIconBoarding} />
              <span>
                {appointmentData?.endDate &&
                  Utils.formatDateStringTz(
                    appointmentData.endDate,
                    appointmentData?.selectedLocation?.timezone,
                    "DD MMM 'yy, hh:mma"
                  )}
              </span>
            </p>
            <p>{t('Check-out Time')}</p>
          </div>
        </div>
      )}
      {(appointmentData?.selectedServiceType === Utils.SERVICE_TYPES.GROOMING ||
        appointmentData?.selectedServiceType === Utils.SERVICE_TYPES.DAY_CARE ||
        appointmentData?.accomodationType === Utils.ACCOMODATION_TYPES.DAY_CARE ||
        (!appointmentData?.selectedServiceType && !appointmentData?.room)) && (
        <div className="time-container">
          <div className="schedule-demo-date">
            <p>
              <img src={DateIcon} />

              <span>
                {appointmentData?.slot &&
                  Utils.getOnlyDate(
                    appointmentData?.slot.start,
                    appointmentData?.selectedLocation?.timezone,
                    'MMM DD, yyyy'
                  )}
              </span>
            </p>
            <p>{t('Scheduled date')}</p>
          </div>
          <div className="schedule-demo-time">
            <p>
              <img src={TimeIcon} />
              <span>
                {appointmentData?.slot &&
                  Utils.getOnlyDate(
                    appointmentData?.slot.start,
                    appointmentData?.selectedLocation?.timezone,
                    'hh:mmA'
                  )}{' '}
                -{' '}
                {appointmentData?.slot &&
                  Utils.getOnlyDate(
                    appointmentData?.slot.end,
                    appointmentData?.selectedLocation?.timezone,
                    'hh:mmA'
                  )}{' '}
                <span className="text-gray-500 text-sm">
                  {Utils.getTzAbbr(appointmentData?.selectedLocation?.timezone)}
                </span>
              </span>
            </p>
            <p>{t('Scheduled time')}</p>
          </div>
        </div>
      )}
      <div className="meeting-details">
        <div className="">
          {appointmentData &&
            ((!appointmentData.selectedServiceType && !appointmentData.room) ||
              appointmentData.selectedServiceType === Utils.SERVICE_TYPES.GROOMING) && (
              <div className="detail service">
                <label>{t('Service Detail')}</label>
                <div>
                  <p>
                    <span className="seperator">
                      {appointmentData?.service && appointmentData?.service.name}
                    </span>
                    <span>
                      {appointmentData?.duration && Utils.minutesToDhm(appointmentData?.duration)}
                    </span>
                  </p>
                  {appointmentData?.selectedAddons && appointmentData?.selectedAddons?.length > 0 && (
                    <div className="addon-services">
                      <ul>
                        {' '}
                        {appointmentData?.selectedAddons.map((addonService) => (
                          <li>+ {addonService.name}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            )}{' '}
          {(appointmentData?.selectedServiceType === Utils.SERVICE_TYPES.DAY_CARE ||
            appointmentData?.accomodationType === Utils.ACCOMODATION_TYPES.DAY_CARE) && (
            <div className="detail service">
              <label>{t('Service Detail')}</label>
              <div>
                <p>
                  <span className="seperator">{t('DayCare Service')}</span>
                  <span>
                    {appointmentData?.duration && Utils.minutesToDhm(appointmentData?.duration)}
                  </span>
                </p>
                {appointmentData?.selectedAddons && appointmentData?.selectedAddons?.length > 0 && (
                  <div className="addon-services">
                    <ul>
                      {' '}
                      {appointmentData?.selectedAddons.map((addonService) => (
                        <li>+ {addonService.name}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          )}
          {(appointmentData?.selectedServiceType === Utils.SERVICE_TYPES.BOARDING ||
            appointmentData?.accomodationType === Utils.ACCOMODATION_TYPES.BOARDING) && (
            <div className="detail service">
              <label>{t('Service Detail')}</label>
              <div>
                <p>
                  <span className="seperator">{t('Boarding Service')}</span>
                  <span>
                    {Utils.totalDaysBooked(appointmentData, undefined, business?.timezone)}
                  </span>
                </p>
                {appointmentData?.selectedAddons && appointmentData?.selectedAddons?.length > 0 && (
                  <div className="addon-services">
                    <ul>
                      {' '}
                      {appointmentData?.selectedAddons.map((addonService) => (
                        <li>+ {addonService.name}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          )}
          {/* {appointmentData?.room && !appointmentData?.selectedServiceType && (
            <div className="detail service">
              <label>Room Detail</label>
              <div>
                <p>
                  <span className="seperator none">
                    {appointmentData?.room && appointmentData?.room.name}
                  </span>
                 
                </p>
              </div>
            </div>
          )} */}
          {registrationRuqired ? (
            <>
              {petData && petData.length > 0 && (
                <div className="detail pet-detail">
                  <label>{t('Pet Detail')}</label>
                  <div className="pet-list-display">
                    {petData.map((pet, index) => (
                      <PetConfirmationDisplay data={pet} showPrice={false} />
                    ))}
                  </div>
                </div>
              )}
              <div className="detail">
                <label>{t('Pet Parent Detail')}</label>
                <p>
                  <span className="seperator">
                    {appointmentData?.parentProfile?.name && appointmentData?.parentProfile.name}
                  </span>
                  <span>
                    {appointmentData?.parentProfile?.phone && appointmentData?.parentProfile?.phone}
                  </span>
                </p>
              </div>
            </>
          ) : (
            <>
              {petData && petData.length > 0 && (
                <div className="detail pet-detail">
                  <label>{t('Pet Detail')}</label>
                  <div className="pet-list-display">
                    {petData.map((pet, index) => (
                      <PetConfirmationDisplay data={pet} showPrice={false} />
                    ))}
                  </div>
                </div>
              )}
              <div className="detail">
                <label>{t('Pet Parent Detail')}</label>
                <p>
                  <span className="seperator">
                    {appointmentData?.userData?.name && appointmentData?.userData.name}
                  </span>
                  <span>
                    {appointmentData?.userData?.phone &&
                      Utils.formatPhoneNumber(appointmentData?.userData?.phone)}{' '}
                  </span>
                </p>
              </div>
            </>
          )}
          {appointmentData &&
            ((!appointmentData.selectedServiceType && !appointmentData.room) ||
              appointmentData.selectedServiceType === Utils.SERVICE_TYPES.GROOMING) && (
              <div className="detail">
                <label>{t('Service Provider')}</label>
                <div className="host-details">
                  <img
                    src={
                      appointmentData?.provider?.avatarUrl
                        ? appointmentData?.provider?.avatarUrl
                        : UserIcon
                    }
                  />
                  <div>
                    <p>{appointmentData?.provider?.name}</p>
                    <p>{appointmentData?.provider?.email}</p>
                  </div>
                </div>
              </div>
            )}
          {registrationRuqired && servicePrice > 0 && (
            <>
              <div className="detail">
                <label>{t('Credit Card')}</label>
                {customerCard && (
                  <p className="credit-card-no">
                    <span> xxxx xxxx xxxx </span>
                    <span className="last">{last4Digit}</span>
                  </p>
                )}
              </div>
              <div className="detail billing">
                <label>{t('Billing Address')}</label>
                {customerCard && (
                  <p>
                    <span className="seperator">
                      {customerCard?.firstName} {customerCard?.lastName}{' '}
                    </span>
                    <span className="address">
                      {' '}
                      {appointmentData.parentProfile &&
                        Utils.getAddress(appointmentData.parentProfile)}
                    </span>
                  </p>
                )}
              </div>
            </>
          )}
          {appointmentData && appointmentData.intakeFormLink && (
            <div className="intake-form-details">
              <label>{t('Next Step')}</label>
              <p>
                {t('Please complete this intake form before your appointment. This is required to be able to accept your pet for this appointment.')}
              </p>
              <div className="action-link">
                <a href={appointmentData.intakeFormLink}>
                  <button className="petsked-button button-light">
                    {t('Complete Intake Form Now')}
                  </button>
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
      {!isPaymentConfirmation && (
        <>
          <div className={appointmentData && appointmentData.intakeFormLink ? "divider-line mt-0" : "divider-line"}></div>
          <p className="email-note">
            {t('Not to worry, the invitation has been sent to your email address')}
          </p>
        </>
      )}
    </div>
  );
};
